<svelte:options accessors/>

<script>
    import cssVars from "svelte-css-vars";
    import { createEventDispatcher  } from "svelte";
    const dispatch = createEventDispatcher();


    let _checked = false
	let _disabled = false
    let _data = { }
    let _label = ""
   
    let default_css_vars = {
        itemSize: "36px",
		borderColor: "#2196F3",
		borderRadius: "0px",
		backgroundColor: "transparent",
		backgroundColorChecked: "#ccc",
		backgroundColorDisabled: "#ccc",
		textColor: "#bbb",
		textColorChecked: "#080808",
		textColorDisabled: "#ececec",
	};
     

    export { _label as label}
    export { _data as data}
    export { _checked as checked}
    export { _disabled as disabled }


	export let iconName = ""
    export  let itemSize = default_css_vars.itemSize
    export  let borderColor = default_css_vars.borderColor
    export  let borderRadius = default_css_vars.borderRadius
    export  let backgroundColor = default_css_vars.backgroundColor
	export 	let backgroundColorChecked = default_css_vars.backgroundColorChecked;
	export let backgroundColorDisabled = default_css_vars.backgroundColorDisabled;
    export  let textColor = default_css_vars.textColor
    export  let textColorChecked = default_css_vars.textColorChecked
    export  let textColorDisabled = default_css_vars.textColorDisabled

    $:  css_vars = {
            ... default_css_vars,
            ...{itemSize, borderColor, backgroundColor, backgroundColorChecked, backgroundColorDisabled, textColorDisabled, borderRadius,textColor, textColorChecked}
    }

    const inputHandler = (ev) => {
        dispatch("change", { checked: _checked, data: _data} )
    }
</script>

<label use:cssVars={css_vars} class="toggle-box" class:disabled={_disabled}>
    <input type="checkbox" bind:checked={_checked} on:change={inputHandler} disabled={_disabled}>
    <div class="checkmark">
		{#if iconName.toLowerCase().length > 0}
			<i class="ui icon {iconName}" style="margin: 0; font-size: 1.3em;"></i>
		 {/if}
			 { _label }
	

    </div>
</label>


<style>
    .toggle-box {
	    cursor: pointer;
		user-select: none;
		height: var(--itemSize);
		width: var(--itemSize);
		display: inline-flex;
		align-content: center;
		justify-content: space-around;
		align-items: center;
		border-radius: var(--borderRadius);

	}

	.toggle-box.disabled  {
		opacity: 0.6;
		background-color: var(--backgroundColorDisabled);
		color: var(--textColorChecked);
	}

	.toggle-box input {
		display: none;	
	}

	/* Create a custom checkbox */
	.checkmark {
		display: inline-flex;
		align-items: center;
		justify-content: center;
    	height: calc(var(--itemSize) - 6px);
    	width: calc(var(--itemSize) - 6px);
		border-radius: var(--borderRadius);
		color: var(--textColor);
	}

	/* On mouse-over, add a grey background color */
	.toggle-box:hover input ~ .checkmark {
		background-color: var(--backgroundColor);
		color: var(--textColorChecked) 
	}

	/* When the checkbox is checked, add a blue background */
	.toggle-box input:checked ~ .checkmark {
		outline: 2px solid var(--borderColor);
		background-color: var(--backgroundColorChecked);
		color: var(--textColorChecked) !important;
	}

	/* Create the checkmark/indicator (hidden when not checked) */
	.checkmark:after {
		content: "";
		position: absolute;
		display: none;
	}
</style>
